
import { TableItemActionsNew } from '../../../../components';
const columns = (actionsList, navigate, setSelectedRow, setRemoveDialog) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام گروه دسترسی',
    field: 'title',
    filtering: false,
    sorting: true,
    align: 'center',
  },
  {
    title: 'توضیحات',
    field: 'description',
    filtering: false,
    sorting: true,
    align: 'center',
  },
  ...((actionsList['addACLUsersBtn'] ||
     actionsList['deleteACLBtn'] || actionsList['updateACLBtn']) ? [{
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'ویرایش دسترسی',
            isShow: !!actionsList['updateACLBtn'],
            onClick: () => {
              navigate(`/Acl/EditGroup/${rowData?.path}`);
            },
          },
          {
            title: 'مشاهده و افزودن کاربر',
            isShow: !!actionsList['addACLUsersBtn'],
            onClick: () => {
              navigate(`/Acl/AddUser/${rowData?.path}?title=${rowData?.title}`);
            },
          },
          {
            title: 'حذف گروه',
            isShow: !!actionsList['deleteACLBtn'],
            onClick: () => {
              setSelectedRow(rowData);
              setRemoveDialog({
                title: 'حذف گروه',
                content: 'آیا از حذف گروه اطمینان دارید؟',
                open: true,
              });
            },
          },
        ]}
      />
    ),

  }] : []),
];
const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, generateData };
